module.exports = __webpack_public_path__ + "static/media/icon-join.1a99c049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-join.png
// module id = 85
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17